import React from 'react';
import ModalContext from './ModalContext';

function reducer(state, action) {
  switch (action.type) {
    case 'toggle':
      return { ...state, isOpen: !state.isOpen };
    case 'close':
      return { ...state, isOpen: false };
    case 'open':
      return { ...state, isOpen: true };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

function ModalProvider({ children }) {
  const [modalState, modalDispatch] = React.useReducer(reducer, {
    isOpen: false,
  });
  const value = [modalState, modalDispatch];

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
}

export default ModalProvider;
